import { SidebarNav as InternalSidebarNav } from "@vetty/internal-ui";
import { SIDEBAR_NAV_ITEMS } from "@/constants/sidebarNavItems.const";
import { SidebarReportAProblemModal } from "@/components";
import { useState } from "react";

const SidebarNav = () => {
  const [isReportProblemModalOpen, setIsReportProblemModalOpen] = useState(false);
  const groups = SIDEBAR_NAV_ITEMS.map((group, index) => ({
    group: group.group,
    collapsible: group.collapsible,
    defaultOpen: group.defaultOpen,
    pinned: index === SIDEBAR_NAV_ITEMS.length - 1,
    items: group.items.map((item) => ({
      href: item.href,
      icon: item.icon,
      label: item.label,
      subItems: item.subItems,
      excludeActivePathPrefixes: item.excludeActivePathPrefixes,
      onClick:
        item.action === "open-report-problem-modal"
          ? () => setIsReportProblemModalOpen(true)
          : undefined,
    })),
  }));

  return (
    <>
      <InternalSidebarNav
        groups={groups}
        productName="Vetty Admin"
        version="version 1.0.0"
        brandmarkSrc="/assets/brandmark-light.svg"
      />
      <SidebarReportAProblemModal
        isOpen={isReportProblemModalOpen}
        onClose={() => setIsReportProblemModalOpen(false)}
      />
    </>
  );
};

export { SidebarNav };
